import { useApiUrl } from '@gemini/lux-ds-pms';
import { OBRoutes } from '@utils/apiRoutes';
import { GeneralInfoDTO } from '@utils/interfaces';
import { useOBQuery } from '@hooks/useOBQuery';
import { mergeObjects } from '@utils/functions';

interface InitialConfigProps {
  practiceId: string;
}

const useGetGeneralPracticeInfo = ({ practiceId }: InitialConfigProps) => {
  const url = useApiUrl(
    OBRoutes.InitialConfig,
    'ONLINEBOOKING_CLIENT_BFF_API_BASE_URL',
  )?.replace('##practiceId', practiceId);

  return useOBQuery<GeneralInfoDTO>(url, {
    enabled: !!url && !!practiceId,
    select: (data: GeneralInfoDTO) => {
      const infoPractice = window.luxOB?.configurations?.infoPractice;
      if (!infoPractice || typeof infoPractice !== 'object') return data;

      // mergeObjects: base = service data, override = infoPractice (infoPractice sovrascrive)
      return mergeObjects<GeneralInfoDTO>(data, infoPractice, true);
    },
  });
};

export default useGetGeneralPracticeInfo;
